module.exports = __webpack_public_path__ + "img/search-icon.456b48df.svg";